import MapComponent from './MapComponent';
export default MapComponent;
